import React from "react";
import { useTable } from "../context";

const LoadMoreLoader = () => {
  const { loadingMoreText, footerHeight, footerRenderer } = useTable();
  return (
    <div
      className="load-more-overlay"
      style={{ bottom: footerRenderer ? `${footerHeight + 16}px` : "16px" }}
    >
      <div>{loadingMoreText}</div>
      <div
        className="oui-spinner-border oui-spinner-border-sm oui-ml-2"
        role="status"
      />
    </div>
  );
};

export default LoadMoreLoader;
